// Registro de cambios (SOLO admin): quien hizo que y cuando.

import { api } from "../api";
import { hoyMontevideo, rangoFechas } from "../../lib/fecha";
import type { AuditoriaFila } from "../../lib/types";

function esc(s: unknown): string {
  return String(s ?? "").replace(/[&<>"]/g, (c) =>
    ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" })[c] as string,
  );
}

// fecha_hora viene en UTC 'YYYY-MM-DD HH:MM:SS'; Montevideo = UTC-3.
function aMvd(utc: string): string {
  const d = new Date(utc.replace(" ", "T") + "Z");
  const local = new Date(d.getTime() - 3 * 3600 * 1000);
  const p = (n: number) => String(n).padStart(2, "0");
  return `${p(local.getUTCDate())}/${p(local.getUTCMonth() + 1)} ${p(local.getUTCHours())}:${p(local.getUTCMinutes())}`;
}

const COLOR_ACCION: Record<string, string> = {
  crear: "bg-green-50 text-green-700",
  editar: "bg-amber-50 text-amber-700",
  borrar: "bg-red-50 text-red-700",
  anular: "bg-red-50 text-red-700",
  suba: "bg-masa-100 text-masa-800",
  clave: "bg-crema-200 text-masa-700",
};

export async function renderAuditoria(contenedor: HTMLElement): Promise<void> {
  const hoy = hoyMontevideo();
  const inicioMes = hoy.slice(0, 8) + "01";

  contenedor.innerHTML = `
    <div class="mb-4 flex flex-wrap items-end justify-between gap-3">
      <div>
        <h1 class="titulo-pagina">Auditoria</h1>
        <p class="subtitulo">Registro de cambios: quien hizo que y cuando (ultimos 300).</p>
      </div>
      <div class="flex flex-wrap items-end gap-2">
        <label><span class="etiqueta">Desde</span><input id="desde" type="date" class="campo" value="${inicioMes}" /></label>
        <label><span class="etiqueta">Hasta</span><input id="hasta" type="date" class="campo" value="${hoy}" /></label>
        <div class="flex gap-1">
          <button class="btn-sec px-2 py-1 text-xs" data-rango="dia">Dia</button>
          <button class="btn-sec px-2 py-1 text-xs" data-rango="semana">Semana</button>
          <button class="btn-sec px-2 py-1 text-xs" data-rango="mes">Mes</button>
          <button class="btn-sec px-2 py-1 text-xs" data-rango="todo">Todo</button>
        </div>
      </div>
    </div>
    <div id="salida" class="tarjeta overflow-x-auto p-0"></div>`;

  const inpDesde = contenedor.querySelector("#desde") as HTMLInputElement;
  const inpHasta = contenedor.querySelector("#hasta") as HTMLInputElement;
  const salida = contenedor.querySelector("#salida") as HTMLElement;

  async function cargar(): Promise<void> {
    salida.innerHTML = `<p class="p-4 text-masa-400">Cargando...</p>`;
    const q = new URLSearchParams();
    if (inpDesde.value) q.set("desde", inpDesde.value);
    if (inpHasta.value) q.set("hasta", inpHasta.value);
    try {
      const filas = await api.get<AuditoriaFila[]>(`/api/auditoria?${q.toString()}`);
      salida.innerHTML = filas.length
        ? `<table class="tabla">
            <thead><tr><th>Fecha</th><th>Usuario</th><th>Accion</th><th>Detalle</th></tr></thead>
            <tbody>${filas
              .map(
                (f) => `<tr>
                  <td class="whitespace-nowrap text-masa-500">${aMvd(f.fecha_hora)}</td>
                  <td class="font-medium">${esc(f.usuario)}</td>
                  <td><span class="rounded-full px-2 py-0.5 text-xs font-semibold ${COLOR_ACCION[f.accion] ?? "bg-crema-100 text-masa-700"}">${esc(f.accion)} ${esc(f.entidad)}</span></td>
                  <td class="text-sm">${esc(f.detalle ?? "")}</td>
                </tr>`,
              )
              .join("")}</tbody>
          </table>`
        : `<p class="p-4 text-masa-400">Sin cambios registrados en el periodo.</p>`;
    } catch (e) {
      salida.innerHTML = `<p class="p-4 text-red-700">${esc(e instanceof Error ? e.message : "Error")}</p>`;
    }
  }

  inpDesde.addEventListener("change", () => void cargar());
  inpHasta.addEventListener("change", () => void cargar());
  contenedor.querySelectorAll<HTMLButtonElement>("[data-rango]").forEach((b) => {
    b.addEventListener("click", () => {
      const tipo = b.dataset.rango as "dia" | "semana" | "mes" | "todo";
      if (tipo === "todo") { inpDesde.value = ""; inpHasta.value = ""; }
      else {
        const ref = inpHasta.value || hoy;
        const [d, h] = rangoFechas(ref, tipo);
        inpDesde.value = d; inpHasta.value = h;
      }
      void cargar();
    });
  });

  await cargar();
}
